<template>
  <div class="library">
    <!-- <bannerof
      style="color: #ffffff"
      :Imgsrc="bannerData.imgUrl"
      :title="bannerData.title"
      :subtitle="bannerData.subtit"
    ></bannerof> -->
    <secondary-banner title="高级职业技能培训库"></secondary-banner>
    <div class="library_center secondary_page_bg">
      <div class="inner libraryAlls">
        <Screening
          @seldata="seldata"
          @pagedata="pagedata"
          @downLoad="handelDownLoad"
          :total="total"
          :checkList="checkList"
          ref="selchilder"
        ></Screening>
        <!-- 资源列表 -->
        <div class="emptyall" v-if="filelist == null">
          <el-empty description="资源努力加载中..."></el-empty>
        </div>
        <div class="emptyall" v-else-if="filelist.length == 0">
          <el-empty description="暂无资源"></el-empty>
        </div>
        <div class="modelist" v-else>
          <metail-item :metailList="filelist" @checkbox="handelCheck"></metail-item>
          <div class="pagwarp">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              :page-size="size"
              :current-page="page"
              @current-change="handleCurrentChange"
              :hide-on-single-page="false"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { saveAs } from 'file-saver';
import Screening from "@/components/screening/index.vue";
import { calSize } from "@/utils";
import { queryES,getFile } from "@/api/library";
import bannerof from "@/components/bannerof";
import SecondaryBanner from "@/components/SecondaryBanner";
import metailItem from "@/components/metailItem/index.vue";
import {getdownload} from "@/utils/request";
export default {
  data() {
    return {
      // FileSaver:require('file-saver'),
      num:0,
      isShowBtn:false,
      checkList:[],//下载数据
      filelist: null,
      typessel: {}, //筛选参数
      total: 0,
      size: 12,
      page: 1,
      baseurl: process.env.VUE_APP_BASE_API,
      keywords: "", //输入框val
      mrimgs: require("@/assets/images/banner.png"),
      mpimg3: require("@/assets/images/mp3img.png"),
      txtimg: require("@/assets/images/textimg.png"),
      mediaType: "", //媒体类型传参
      sortName: "", //排序
      sampleType: "",
      bannerData: {
        title: "",
        subtit: "",
        imgUrl: require("@/assets/images/ziliaoKu.png"),
      },
    };
  },
  components: { Screening, bannerof, SecondaryBanner, metailItem },
  props: ["filelista"],
  created() {
    this.$store.commit("user/SET_TABINDEX", 1040);
  },
  mounted() {
    this.filelistall(this.keywords);
  },
  filters: {
    calSize(fileSize) {
      return calSize(fileSize);
    },
  },
  methods: {
    formatUrl(url) {
      var str = new RegExp("http");
      if (str.test(url)) {
        return url;
      } else {
        return url == null
          ? url
          : url.startsWith("/profile")
          ? this.baseurl + url
          : this.baseurl + "/profile/" + url;
      }
    },

    // 资源列表
    filelistall(keywords, page) {
      if (page !== undefined) {
        this.page = page;
      }
      // 判断 keywords是否有值
      this.keywords = keywords || "";
      // copy筛选列表id
      const typeobj = JSON.parse(JSON.stringify(this.typessel));

      // 获取筛选列表的键
      const keyArr = Object.keys(typeobj);
      // 利用数组的求和方法合并列表的id是否有值
      const newArr = keyArr.reduce(function (prev, curr) {
        return [...prev, ...typeobj[curr]];
      }, []);
      var datas = {
        keywords: this.keywords,
        mediaType: this.mediaType,
        sample: this.sampleType,
        sortName: this.sortName,
        status: 2,
      };
      if (newArr.length > 0) {
        // 有值说明要传types
        var newObj = {};
        for (let key in typeobj) {
          // 循环筛选对象
          if (typeobj[key].length > 0) {
            //判断单个筛选对象中是否有值 为true进行下一步
            // 数组转字符串以空格分隔
            newObj[key] = typeobj[key].join(" ");
          }
        }
        datas = {
          keywords: this.keywords,
          types: newObj,
          mediaType: this.mediaType,
          sample: this.sampleType,
          sortName: this.sortName,
          status: 2,
        };
      }
      queryES(datas, { size: this.size, page: this.page })
        .then((res) => {
          if (res.code == 200) {
            res.rows.forEach((value, index) => {
              if(this.isShowBtn==true){
                value["mywidshow"] = true;
              }else{
                value["mywidshow"] = false;
              }
              if(value.content.material.allowDownload==false){
                value["disabled"]=true
              }else{
                value["disabled"]=false
              }
              value["checkbol"] = false;
            });
            this.filelist = res.rows;
            this.total = res.total;
          }

          this.fullscreenLoading = false;
        })
        .catch((err) => {
          this.fullscreenLoading = false;
        });
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val;
      this.filelistall(this.keywords);
    },
    //筛选数据
    seldata(msg) {
      this.typessel = msg;
    },
    //子组件传出的下载数据
    handelCheck(item){
      if (item.checkbol == true) {
        this.checkList.push(item)
      } else {
        for (let index = 0; index < this.checkList.length; index++) {
          const checkitem = this.checkList[index];
          if (checkitem.id == item.id) {
            let ind = index;
            this.checkList.splice(ind, 1);
          }
        }
      }
    },
    //子组件传的下载事件
    handelDownLoad(val){
      if(val.typeValue==1){
        this.filelist.forEach((value, index) => {
          this.isShowBtn=true
          value["mywidshow"] = true;
          value["checkbol"] = false;
        });
        this.checkList=[]
        //取消下载
      }else if(val.typeValue==2){
        this.isShowBtn=false
        this.filelist.forEach((value, index) => {
          value["mywidshow"] = false;
          value["checkbol"] = false;
        });
        this.checkList=[]
        //批量下载
      }else if(val.typeValue==3){
        if(this.checkList.length!=0){
          this.isShowBtn=false
          this.filelist.forEach((value, index) => {
            value["mywidshow"] = false;
            value["checkbol"] = false;
          });
          //循环掉接口
          this.checkList.forEach((value, index) => {
            if(value.content.material){
            getdownload('business/material/getFile',{fileId:value.content.id},value.content.material.originalName)
            }
          });
        }else{
          this.$message({
            message: '请选择下载的文件',
            type: 'error',
            iconClass: ' ', // 这个会覆盖图标类名，为了实现去掉图标的操作
            customClass: 'el-message--error', // 这个是由于上面设置了iconClass会覆盖掉type，所以需要再设置
          });
        }
      }
    },
    //子组件传的分页数据
    pagedata(val) {
      this.page = val.page;
      if (val.sortName !== undefined) {
        this.sortName = val.sortName;
      } else if (val.mediaType !== undefined) {
        this.mediaType = val.mediaType;
      } else if (val.sampleType !== undefined) {
        this.sampleType = val.sampleType;
      } else if (val.typessel !== undefined) {
        this.typessel = val.typessel;
      } else if (val.keywords !== undefined) {
        this.keywords = val.keywords;
      }
      this.filelistall(this.keywords);
    },
  },
};
</script>
<style scoped lang="scss">
.library_center {
  padding-bottom: 40px;
  overflow: hidden;
}
.libraryAlls {
  margin-top: 50px;
  padding: 5px 20px;
  border-radius: 8px;
  background-color: #ffffff;
}
/* 资源列表 */
/* 空数据时 */
.emptyall {
  width: 100%;
  height: 500px;
  text-align: center;
  background-color: #fff;
}
.modelist {
  margin-top: 17px;
}
.achie_model {
  width: 23%;
  height: 286px;
  border-radius: 10px;
  background-color: #fff;
  overflow: hidden;
  cursor: pointer;
  margin: 12px 1%;
  transition: all 0.4s;
  border: 1px solid #eeeeee;
}

.achie_tops {
  height: 158px;
  border-radius: 3px;
  overflow: hidden;
}

.achie_model:hover {
  box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
}

.achie_model:hover .el-image {
  transform: scale(1.2);
}
.achie_tops > .el-image {
  width: 100%;
  height: 100%;
  transition: all 0.4s;
  font-size: 50px;
  line-height: 150px;
  color: #b3b3b3;
  text-align: center;
}
/* 介绍 */
.achie_text {
  width: 100%;
  font-size: 14px;
  color: gray;
}
.achiebotms {
  height: 49px;
  line-height: 25px;
  padding: 15px 10px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  border-bottom: 1px solid #f2f2f2;
}
.pcont {
  font-size: 18px;
  color: #181818;
}
.achie_sp {
  width: 100%;
  height: 30px;
  padding: 0 10px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
}

.txtp1,
.txtp2 {
  height: 25px;
}
.txtp1 {
  width: 60%;
  text-align: left;
}
.txtp2 {
  width: 40%;
  text-align: right;
}
.viewicon {
  color: #B18227;
  font-weight: bold;
  font-size: 15px;
}
.txtp3 {
  width: 55%;
  height: 25px;
}
/* 发布人 */
.creaname {
  width: 45%;
  float: right;
  text-align: right;
  color: #b3b3b3;
}
.txtcolors {
  color: #b3b3b3;
}
/* 分页 */
.pagwarp {
  width: 100%;
  margin: 30px auto;
  text-align: center;
}
</style>
<style lang="scss">
.modelist {
  .metailItemwarp {
    .achie_model {
      .achie_model_inner {
        border: 1px solid #eeeeee;
      }
    }
  }
}
</style>
